import { endpoints, baseurl } from "../Utils/Constants";

// POST /api/dashboard/ai-feedback  { session_id, chat_id, sentiment: "like" | "dislike" }
// `sessionId` groups the whole conversation; `chatId` is the one response being rated.
// Both are the uuids the client generated and sent with the AI request. Re-rating the
// same chatId overwrites the sentiment server-side — it never duplicates.
export const submitAiFeedback = async (sessionId, chatId, sentiment, token) => {
  try {
    const response = await fetch(baseurl + endpoints.DASHBOARD_AI_FEEDBACK, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ session_id: sessionId, chat_id: chatId, sentiment }),
    });
    return await response.json();
  } catch (error) {
    console.error("Error submitting AI feedback:", error);
    return { is_success: false, message: error.message || "Failed to submit feedback." };
  }
};
